// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"1c8d3ac1","239":"31127400","977":"f04bf757"}[chunkId] + ".chunk.js";
};